/**
 * Article section — toolbar visibility + hero parallax (Prestige ArticleSection + Rellax).
 */
(function () {
  function supportsHoverParallax() {
    return window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches;
  }

  function ArticleSection(container) {
    this.element = container;
    this.toolbarElement = this.element.querySelector('[data-article-toolbar], .ArticleToolbar');
    this.articleNavElement = this.element.querySelector('.ArticleNav');
    this.imageElement = this.element.querySelector('.Article__Image');
    this.parallaxInstance = null;
    this._onScrollListener = this._checkToolbarVisibility.bind(this);
    this._onResizeListener = this._refreshParallax.bind(this);
    this._onLoadListener = this._refreshParallax.bind(this);

    if (this.imageElement && supportsHoverParallax() && typeof window.Rellax === 'function') {
      this.element.classList.add('is-parallax');
      this._initParallax();
      window.addEventListener('load', this._onLoadListener);
    }

    this._attachListeners();
    this._checkToolbarVisibility();
  }

  ArticleSection.prototype._initParallax = function () {
    if (!this.imageElement || typeof window.Rellax !== 'function') return;

    if (this.parallaxInstance && typeof this.parallaxInstance.destroy === 'function') {
      this.parallaxInstance.destroy();
    }

    this.parallaxInstance = new window.Rellax(this.imageElement, {
      speed: -7,
      center: false,
      round: true
    });
  };

  ArticleSection.prototype._refreshParallax = function () {
    var self = this;
    window.requestAnimationFrame(function () {
      if (self.parallaxInstance && typeof self.parallaxInstance.refresh === 'function') {
        self.parallaxInstance.refresh();
      } else if (self.imageElement && supportsHoverParallax()) {
        self._initParallax();
      }
    });
  };

  ArticleSection.prototype._attachListeners = function () {
    window.addEventListener('scroll', this._onScrollListener, { passive: true });
    window.addEventListener('resize', this._onResizeListener, { passive: true });
  };

  ArticleSection.prototype.destroy = function () {
    window.removeEventListener('scroll', this._onScrollListener);
    window.removeEventListener('resize', this._onResizeListener);
    window.removeEventListener('load', this._onLoadListener);
    this.element.classList.remove('is-parallax');

    if (this.parallaxInstance && typeof this.parallaxInstance.destroy === 'function') {
      this.parallaxInstance.destroy();
      this.parallaxInstance = null;
    }
  };

  ArticleSection.prototype._checkToolbarVisibility = function () {
    var toolbar = this.toolbarElement;
    if (!toolbar) return;

    var lastYPosition = window.pageYOffset || document.documentElement.scrollTop;
    var header = document.querySelector('.Header, .section-header, header-component, #shopify-section-header');
    var headerHeight = header ? header.offsetHeight : 0;
    var stickyVar = getComputedStyle(document.body).getPropertyValue('--use-sticky-header');
    var isFixedHeader = parseInt(stickyVar || '0', 10);

    if (isFixedHeader) {
      toolbar.style.top = headerHeight + 'px';
    } else {
      toolbar.style.top = '';
    }

    var show = false;
    if (this.articleNavElement && this.articleNavElement.offsetParent !== null) {
      var navBottom =
        this.articleNavElement.offsetTop + this.articleNavElement.clientHeight - headerHeight;
      show = lastYPosition > 150 && lastYPosition < navBottom;
    } else {
      show = lastYPosition > 150;
    }

    toolbar.classList.toggle('is-visible', show);
  };

  function initAll() {
    document.querySelectorAll('[data-ci-article], [data-section-type="article"]').forEach(function (el) {
      if (el._ciArticleSection) {
        el._ciArticleSection.destroy();
      }
      el._ciArticleSection = new ArticleSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ci-article], [data-section-type="article"]');
    if (section) {
      if (section._ciArticleSection) section._ciArticleSection.destroy();
      section._ciArticleSection = new ArticleSection(section);
    }
  });
})();
